import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './PartnersSection.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

export default function PartnersSection() {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/partners/public`)
      .then((res) => {
        if (mounted) setPartners(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setPartners([]);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (partners.length === 0) return null;

  return (
    <section className="partners reveal">
      <span className="partners__eyebrow">Our Partners</span>
      <div className="partner-row">
        {partners.map((p) => (
          p.website_url ? (
            <a href={p.website_url} target="_blank" rel="noreferrer" className="partner-logo" key={p.id}>
              {p.logo_url ? <img src={p.logo_url} alt={p.name} /> : p.name}
            </a>
          ) : (
            <div className="partner-logo" key={p.id}>
              {p.logo_url ? <img src={p.logo_url} alt={p.name} /> : p.name}
            </div>
          )
        ))}
      </div>
    </section>
  );
}
